mutation WorkgroupGroupDelete($input: WorkgroupGroupDeleteInput!) {
  workgroupGroupDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
